export default "__VITE_ASSET__Dh5Tc3Cd__"